/**
 * Dialogs opened from a dropdown menu item have no trigger of their own (the item unmounts), so
 * Radix would return focus to <body> on close. Menu items record their menu's trigger here and a
 * dialog opened within a moment adopts it as its focus-return target.
 */
let pending: { element: HTMLElement; at: number } | null = null;

export function rememberMenuTrigger(element: HTMLElement | null) {
  pending = element ? { element, at: Date.now() } : null;
}

export function takeMenuTrigger(): HTMLElement | null {
  const candidate = pending;
  pending = null;
  return candidate && Date.now() - candidate.at < 1500 ? candidate.element : null;
}

export function restoreFocus(element: HTMLElement | null, event: Event) {
  if (element && element.isConnected) {
    event.preventDefault();
    element.focus();
  }
}
